(function () {
  function scrollTrack(track, direction) {
    if (!track) return;
    var cell = track.querySelector('.bff-showcase__cell, .bff-type-row__cell');
    var step = cell ? cell.getBoundingClientRect().width + 14 : track.clientWidth * 0.85;
    track.scrollBy({ left: step * direction, behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var prevBtn = e.target.closest('[data-bff-showcase-prev]');
    var nextBtn = e.target.closest('[data-bff-showcase-next]');
    if (!prevBtn && !nextBtn) return;
    var wrap = (prevBtn || nextBtn).closest('.bff-showcase__track-wrap, .bff-type-row__track-wrap');
    var track = wrap && wrap.querySelector('[data-bff-showcase-track]');
    scrollTrack(track, prevBtn ? -1 : 1);
  });
})();
